import React from "react";
import ArabicRegistrationJSON from "./ArabicRegistrationJSON";
import NewRegArabic from "./NewRegArabic";

export default function ArabicUpdaterPage() {
  return (
    <section>
      <NewRegArabic />
      <ArabicRegistrationJSON />
    </section>
  );
}
